// extracted by mini-css-extract-plugin
module.exports = {"UserRepos":"UserRepos_UserRepos__rgo2r","Heading":"UserRepos_Heading__n_OWR"};